import React, { useMemo } from 'react';
import { Flex, FlexItem, DateQuantity } from '@erecruit/ui-kit';
import {
  Modifier as CalendarModifier,
  RangeModifier as CalendarRangeModifier,
} from '@erecruit/ui-kit/src/molecules/Calendar/Calendar';
import moment, { Moment } from 'moment';

export const DatesSelectionInfo = ({
  selectedDates,
  selectedDatesQuantities,
  onDateQuantityChange,
  onDateRemove,
}: {
  selectedDates: Record<string, CalendarModifier>;
  selectedDatesQuantities: Record<string, number>;
  onDateQuantityChange: (key: string, quantity: number) => void;
  onDateRemove: (key: string) => void;
}) => {
  const elements: JSX.Element[] = useMemo(
    () =>
      Object.keys(selectedDates).map(key => {
        const selectedDay = selectedDates[key];
        const quantity = selectedDatesQuantities[key];

        let range: Moment | [Moment, Moment];
        if (Object.keys(selectedDay as object).length === 0) {
          // it's a Date
          range = moment(selectedDay as Date);
        } else {
          const selected = selectedDay as CalendarRangeModifier;
          range = [moment(selected.from), moment(selected.to)];
        }

        const onQuantityChange = (newQuantity: number) => {
          onDateQuantityChange(key, newQuantity);
        };

        const onRemove = () => {
          onDateRemove(key);
        };

        return (
          <FlexItem key={key}>
            <DateQuantity
              defaultValue={quantity}
              dateRange={range}
              onQuantityChange={onQuantityChange}
              onRemove={onRemove}
            />
          </FlexItem>
        );
      }),
    [
      onDateQuantityChange,
      onDateRemove,
      selectedDates,
      selectedDatesQuantities,
    ],
  );

  return (
    <Flex gutter={4} gutterDirection="vertical" direction="column">
      {elements}
    </Flex>
  );
};
